import { useFlags } from 'launchdarkly-react-client-sdk';

import { USE_NEEDS_ACTION_CORRECTIONS_TABLE_FLAG } from '@/constants/feature-flagging';

/**
 * Reads the needs-action corrections table feature flag.
 *
 * Gates whether the corrections-based variant of the Needs Action table is
 * shown instead of the legacy itineraries table. The flag is targeted per-org
 * in LaunchDarkly via the `orgResourceId` custom context attribute set in
 * `ldClient.identify`.
 *
 * @returns {boolean} true when the corrections table should be shown
 */
const useIsCorrectionTableEnabled = () => {
  const flags = useFlags();

  return Boolean(flags[USE_NEEDS_ACTION_CORRECTIONS_TABLE_FLAG]);
};

export default useIsCorrectionTableEnabled;
